import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ExpressPayComponent } from './express-pay/express-pay.component';

const routes: Routes = [
	{ path: 'ExpressPay', component: ExpressPayComponent},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ExpressPayRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/payment/express-pay/express-pay-routing.module.ts